import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';
import { formatISO, isDate } from 'date-fns';

import { useApi } from '@/composables/useApi';

export default defineStore('agent/qlp', () => {
	const VueRoute = useRoute();

	const views = ref(null);
	const rows = ref([]);
	const rowCount = ref(0);
	const overviewData = ref({});
	const chartData = ref({
		domain_name: [],
		path: [],
		cmpid: [],
	});
	const overviewDataLoading = ref(true);
	const rowsLoading = ref(true);

	async function getStats(
		start,
		end,
		page,
		includeUncampaigned = true,
		pageSize = 15,
		sortKey = 'page_views',
		sortDescending = true,
		domainFilter = [],
		rowsOnly = false
	) {
		if (!isDate(start) || !isDate(end)) {
			throw 'Valid start and end dates required';
		}

		rowsLoading.value = true;
		if (!rowsOnly) {
			overviewDataLoading.value = true;
		}

		const { data } = await useApi(
			`api/agents/${VueRoute.params.agentID}/campaigns/?${new URLSearchParams({
				start: formatISO(start).substring(0, 19),
				end: formatISO(end).substring(0, 19),
				page: page ? page : 1,
				include_uncampaigned: includeUncampaigned,
				page_size: pageSize,
				sort_key: sortKey,
				sort_descending: sortDescending,
				domain_filter: domainFilter.join(),
			})}`,
			{
				message:
					'There was an issue retrieving your QLP stats from the server! Please try again later.',
			}
		).json();

		rows.value = data.value.results;
		rowCount.value = data.value.count;
		rowsLoading.value = false;
		if (rowsOnly) {
			return;
		}
		overviewDataLoading.value = false;
		overviewData.value = data.value.overview_data;
		chartData.value = data.value.chart_data;
	}

	async function getViews(start, end) {
		if (!isDate(start) || !isDate(end)) {
			throw 'Valid start and end dates required';
		}

		const { data } = await useApi(
			`api/agents/${VueRoute.params.agentID}/campaigns/qlp_views/?${new URLSearchParams({
				start: formatISO(start).substring(0, 19),
				end: formatISO(end).substring(0, 19),
			})}`,
			{
				message:
					'There was an issue retrieving your QLP stats from the server! Please try again later.',
			}
		).json();
		views.value = data.value?.qlp_views;
	}

	return {
		views,
		rows,
		rowCount,
		overviewData,
		chartData,
		overviewDataLoading,
		rowsLoading,
		getStats,
		getViews,
	};
});
